import TenDaysFreeTrialNew from "./components/HomePageCopy/TenDaysFreeTrialNew";
import HomeCopy from "./components/HomePageCopy/HomeCopy";

export const route = [
    {
        id: 1,
        name: "HomeCopy",
        path: "/",
        component: <HomeCopy />,
        
    },
    {
        id: 2,
        name: "TenDaysFreeTrialNew",
        path: "/10-days-free-trial-new",
        component: <TenDaysFreeTrialNew />,
        
    }

]